import ImageViewer from 'react-native-image-zoom-viewer';
import styled from 'styled-components/native';
import { AppIconButton } from '@/components/base/app.icon.button';
import { Box } from '@/components/base/box';
import { AppModal } from '@/components/compose/app.modal';
import { useAppRouter } from '@/hooks/use.app.router';
import { wpVal } from '../../utils';

export default function ImageZoomModal() {
  const router = useAppRouter();
  const { params } = useAppRouter();
  const imagePath = (params as any).imagePath;
  return (
    <AppModal>
      <ImageViewer imageUrls={[{ url: imagePath }]} renderIndicator={() => null} />
      <BackButtonContainer>
        <AppIconButton icon={'back'} onPress={() => router.goBack()} />
      </BackButtonContainer>
    </AppModal>
  );
}

const BackButtonContainer = styled(Box)`
  position: absolute;
  top: ${wpVal(4)};
  left: ${wpVal(2)};
`;
